var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-navigation'),_c('v-content',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('child')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }